<div class="layout-main">
  <div class="container-fluid">
    <div class="pb-2 mb-3 border-bottom">
      <h3><b>Encryption keys logs</b></h3>
    </div>
    <div class="row">
      <div class="col-12">
        <p-panel [toggleable]="true">
          <ng-template pTemplate="header">
            <div class="filter-card-header">
              <span class="filter-icon"><i class="fa fa-search"></i></span>
              <span class="filter-card-title">Filter</span>
            </div>
          </ng-template>
          <div class="filter-fields">
            <div class="filter-field">
              <p-floatLabel>
                <p-dropdown (onChange)="filter()" [(ngModel)]="encryptionKeysLogsFilterCriteria.company"
                            [filter]="true" [options]="companyItems" name="company" showClear="true"></p-dropdown>
                <label>Company</label>
              </p-floatLabel>
            </div>
            <div class="filter-field">
              <p-floatLabel>
                <p-dropdown (onChange)="filter()" [(ngModel)]="encryptionKeysLogsFilterCriteria.user"
                            [filter]="true" [options]="userItems" name="user" showClear="true"></p-dropdown>
                <label>User</label>
              </p-floatLabel>
            </div>
            <div class="filter-field">
              <p-floatLabel>
                <p-dropdown (onChange)="filter()" [(ngModel)]="encryptionKeysLogsFilterCriteria.action"
                            [options]="actionItems" name="action"></p-dropdown>
                <label>Action</label>
              </p-floatLabel>
            </div>
            <div class="filter-field">
              <p-floatLabel>
                <p-calendar (onClearClick)="filter()" (onInput)="filter()" (onSelect)="filter()"
                            [(ngModel)]="encryptionKeysLogsFilterCriteria.dateFrom" [showButtonBar]="true"
                            [showIcon]="true" [style]="{'width':'100%'}" dataType="string" dateFormat="mm/dd/yy"
                            inputId="logsDateFrom" name="logsDateFrom"></p-calendar>
                <label for="logsDateFrom">From</label>
              </p-floatLabel>
            </div>
            <div class="filter-field">
              <p-floatLabel>
                <p-calendar (onClearClick)="filter()" (onInput)="filter()" (onSelect)="filter()"
                            [(ngModel)]="encryptionKeysLogsFilterCriteria.dateTo" [showButtonBar]="true"
                            [showIcon]="true" [style]="{'width':'100%'}" dataType="string" dateFormat="mm/dd/yy"
                            inputId="logsDateTo" name="logsDateTo"></p-calendar>
                <label for="logsDateTo">To</label>
              </p-floatLabel>
            </div>
            <div class="filter-actions">
              <button (click)="reset()" class="filter-reset-btn" type="button">
                <i aria-hidden="true" class="fa fa-refresh"></i>
                Reset
              </button>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
    <p-table (sortFunction)="tableService.customSort($event)" [columns]="columns" [customSort]="true"
             [loading]="loading" [paginator]="true" [rows]="30" [value]="filteredEncryptionKeysLogs"
             id="prod_encryption_keys_logs">
      <ng-template pTemplate="loadingicon">
        <p-progressSpinner [style]="{width: '48px', height: '48px'}" animationDuration="1.2s"
                           strokeWidth="4"></p-progressSpinner>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" [pSortableColumnDisabled]="col.sortDisabled" [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon *ngIf="!col.sortDisabled" [field]="col.field" ariaLabel="Activate to sort"
                        ariaLabelAsc="Activate to sort in ascending order"
                        ariaLabelDesc="Activate to sort in descending order"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template let-key pTemplate="body">
        <tr>
          <td class="when-cell">{{ key.date | date:'MMM d, y H:mm' }}</td>
          <td class="record-cell">{{ key.logDescription }}</td>
          <td>
            <span class="action-badge action-badge--{{ key.action | lowercase }}">{{ key.action | titlecase }}</span>
          </td>
          <td class="actor-cell">{{ getUserName(key) }}</td>
          <td>{{ key.companyName }}</td>
          <td>{{ key.method }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columns?.length">
            <div *ngIf="loadError" class="empty-state">
              <i aria-hidden="true" class="fa fa-exclamation-triangle"></i>
              <div class="empty-state-title">The logs could not be loaded</div>
              <div class="empty-state-subtitle">Please try again later.</div>
            </div>
            <div *ngIf="!loadError" class="empty-state">
              <i aria-hidden="true" class="fa fa-search"></i>
              <div class="empty-state-title">No log found</div>
              <div class="empty-state-subtitle">Try adjusting your filters.</div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
